import React, { useEffect, VFC } from "react";

import { ValueFieldProps } from "@sitecore-jss/sitecore-jss-react-forms/types";
import { StringInputViewModel } from "@sitecore-jss/sitecore-jss-forms";
import BaseTextField from "../baseTextField";
import { useSelector } from "react-redux";
import { IReduxState } from "../../../ReduxImpl/reducers";

const EmailConfirmationField = (props) => {
  const state = useSelector((state: IReduxState) => {
    return state;
  });
  useEffect(() => {
    if (state.fieldValues[props.field.model["conditionSettings"].fieldKey]) {
      props.field.model.confirmEmail =
        state.fieldValues[props.field.model["conditionSettings"].fieldKey];
    }
  }, [state]);
  useEffect(() => {
    console.log(props);
  }, [props]);
  return (
    <div style={{ display: "flex" }}>
      <div style={{ width: "100%" }}>
        <BaseTextField type="emailValidator" {...props} />
      </div>
    </div>
  );
};

export default EmailConfirmationField;
